import _ from "lodash";
import Grid from "@mui/material/Grid";
import PatientStatusFilter from "./PatientStatusFilter";

const PatientTabFilters = props => {
  const {counts} = props;

  return (
    <Grid
      container
      columnSpacing={{xs: 0, lg: 5.25, xl: 8.25}}
      rowSpacing={{lg: 2}}
      sx={{
        padding: {xs: '0', lg: '9px 11px'},
        flexWrap: {xs: 'wrap', lg: 'nowrap'}
      }}
    >
      {
        Object.keys(counts || {}).map(key =>
          <Grid item xs={12} lg="auto"
            sx={{
              backgroundColor: {
                xs: key === _.camelCase(props.filters?.patient_status ?? 'All') 
                ? 'var(--button-fill)' 
                : 'transparent', lg: 'transparent'
              },
              '&:not(:last-child)': {
                borderBottom: {xs: '1px solid var(--button-stroke)', lg: 'none'},
              },
              cursor: 'pointer'
            }}
          >
            <PatientStatusFilter  
              {...props} 
              count={counts[key]} 
              itemName={key} 
              useText={true}
            />
          </Grid>
        )
      }
    </Grid>
  );
};
export default PatientTabFilters;
